import React, { FC } from 'react';
import { CustomIcon } from './label-icon';
import { classes, stylesheet } from 'typestyle';
import swanIcon from '@src/images/icons/swan-logo.svg';

import { getLabelColor, getLabelDarkModeColor } from './label-color';
import { Label } from './types';
import { useFormatMessage } from '@src/i18n';

type LabelPreviewProps = {
  label: Label;
  columns: [number, number];
  isValid: boolean;
};

// TODO: Well, this is a default label color when enable_high_contrast flag is disabled
// Would be great to synchronize the look and feel as this may not exactly match the widget
const DEFAULT_LABEL_PREVIEW_COLOR = '#949494';

// TODO: Hardcoded as actually there is no place to get this color from, as above.
const CHECKOUT_DARK_MODE_BACKGROUND = '#121212';

export const LabelPreview: FC<LabelPreviewProps> = ({ columns, label, isValid }) => {
  const formatMessage = useFormatMessage();

  return (
    <div className="ant-row ant-form-item">
      <div className={`ant-col ant-col-${columns[0]}`}>
        <label className="ant-form-item-no-colon">{formatMessage('LABEL_PREVIEW.HEADER')}</label>
      </div>
      <div className={`ant-col ant-col-${columns[1]} ant-form-item-control`}>
        <div className="ant-form-item-control-input">
          {isValid && (
            <div className={styles.container}>
              <Variant header={formatMessage('LABEL_PREVIEW.LIGHT_MODE')} label={label} />
              <Variant header={formatMessage('LABEL_PREVIEW.DARK_MODE')} label={label} darkMode />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const Variant = ({
  header,
  label,
  darkMode = false,
}: {
  header: string;
  label: Label;
  darkMode?: boolean;
}) => {
  const labelColor = getLabelColor(label) ?? DEFAULT_LABEL_PREVIEW_COLOR;
  const color = darkMode ? getLabelDarkModeColor(label) || labelColor : labelColor;
  return (
    <div>
      <span>{header}</span>
      <div className={classes(styles.wrapper, { [styles.darkModeWrapper]: darkMode })}>
        <PreviewIcon label={label} color={color} />
        <span style={{ color }} className={styles.label}>
          {label.name}
        </span>
      </div>
    </div>
  );
};

const PreviewIcon: FC<{ label: Label; color: string }> = ({ label, color }) => {
  if (label.type === 'LABEL_TYPE_SWAN') {
    return (
      <img aria-hidden="true" src={swanIcon} width="16px" height="16px" className={styles.icon} />
    );
  }

  if (!label.icon) {
    return null;
  }

  return <CustomIcon aria-hidden="true" color={color} name={label.icon} className={styles.icon} />;
};

const styles = stylesheet({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    padding: '8px',
  },
  darkModeWrapper: {
    backgroundColor: CHECKOUT_DARK_MODE_BACKGROUND,
  },
  icon: {
    marginRight: '4px',
  },
  label: {
    fontSize: '12px',
    lineHeight: '16px',
    textWrap: 'wrap',
  },
});
